module.exports = __webpack_public_path__ + "static/media/hira-transcript.be668eb7.jpg";